module.exports = __webpack_public_path__ + "static/media/File.8a7ee879.png";